import { useEffect, useState } from 'react';

/**
 * Узкий ли экран. Порог тот же, что у Tailwind (`md` = 768px) и у мобильной
 * темы в `index.css` — иначе получилась бы полоса ширин, где цвета уже
 * песочные, а раскладка ещё десктопная.
 *
 * Нужен там, где мобильный экран — это ДРУГАЯ раскладка, а не та же в узкой
 * колонке (главная по макету от 23.08.2026). Где хватает `md:` — обходимся без
 * него: лишний слушатель на каждый экран ничего не даёт.
 */
const QUERY = '(max-width: 767px)';

// Без `matchMedia` (jsdom в проверках, где его не подменили) — широкий экран, как раньше у оболочки: с 13.10.2026 её
// рисуют проверки переводчика, и падение здесь роняло бы весь кабинет в них, а не только телефонную ветку.
const hasMatchMedia = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export function useIsMobile(): boolean {
  const [is, setIs] = useState(() => (hasMatchMedia() ? window.matchMedia(QUERY).matches : false));
  useEffect(() => {
    if (!hasMatchMedia()) return;
    const mq = window.matchMedia(QUERY);
    const onChange = () => setIs(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return is;
}
